import useInsuranceStore from "../storeModules/useInsuranceStore";
import useUserStore from "../storeModules/useUserStore";
import usePaymentStore from "../storeModules/usePaymentStore";
import useBotControlStore from "../storeModules/useBotControlStore";
import useConsorcioStore from "../storeModules/useConsorcioStore";
import { clearSessionConfigStorage } from "./sessionConfigStorage";

export const LOCAL_STORAGE_INSURANCE_KEY = "mycon_insurance_store";
export const LOCAL_STORAGE_CUPOM_DATA_KEY = "mycon_cupom_data";
export const LOCAL_STORAGE_USER_CUPOM_KEY = "mycon_user_cupom";
export const LOCAL_STORAGE_COUPON_FIRST_PARCEL_KEY = "mycon_coupon_first_parcel";
export const LOCAL_STORAGE_STEP_TO_BACK_KEY = "mycon_step_to_back";
export const LOCAL_STORAGE_CREDIT_RANGES_KEY = "mycon_credit_ranges";

export const persistCreditRanges = (ranges) => {
  try {
    localStorage.setItem(LOCAL_STORAGE_CREDIT_RANGES_KEY, JSON.stringify(ranges));
  } catch (_) {}
};

export const persistInsuranceStore = () => {
  try {
    const {
      idCotacao,
      valorPremio,
      dataCotacao,
      isInsuranceHired,
      termsAcceptDate,
      termsVersion,
    } = useInsuranceStore.getState();
    localStorage.setItem(
      LOCAL_STORAGE_INSURANCE_KEY,
      JSON.stringify({
        idCotacao,
        valorPremio,
        dataCotacao,
        isInsuranceHired,
        termsAcceptDate,
        termsVersion,
      })
    );
  } catch (_) {}
};

export const persistCupomStore = () => {
  try {
    const { userCupom, cupomData } = useUserStore.getState();
    const { couponFirstParcel } = usePaymentStore.getState();
    localStorage.setItem(LOCAL_STORAGE_USER_CUPOM_KEY, userCupom || "");
    localStorage.setItem(LOCAL_STORAGE_CUPOM_DATA_KEY, JSON.stringify(cupomData));
    localStorage.setItem(
      LOCAL_STORAGE_COUPON_FIRST_PARCEL_KEY,
      String(couponFirstParcel || 0)
    );
  } catch (_) {}
};

export const persistStepToBack = (stepIndex) => {
  try {
    localStorage.setItem(LOCAL_STORAGE_STEP_TO_BACK_KEY, String(stepIndex));
  } catch (_) {}
};

export const restoreResumeStorage = () => {
  try {
    const savedInsurance = localStorage.getItem(LOCAL_STORAGE_INSURANCE_KEY);
    if (savedInsurance) {
      useInsuranceStore.setState(JSON.parse(savedInsurance));
    }
  } catch (_) {}

  try {
    const savedCupom = localStorage.getItem(LOCAL_STORAGE_CUPOM_DATA_KEY);
    const savedUserCupom = localStorage.getItem(LOCAL_STORAGE_USER_CUPOM_KEY);
    const savedCouponParcel = localStorage.getItem(LOCAL_STORAGE_COUPON_FIRST_PARCEL_KEY);
    if (savedCupom || savedUserCupom) {
      useUserStore.setState((state) => ({
        ...state,
        ...(savedUserCupom && { userCupom: savedUserCupom }),
        ...(savedCupom && { cupomData: JSON.parse(savedCupom) }),
      }));
    }
    if (savedCouponParcel) {
      usePaymentStore.setState({
        couponFirstParcel: parseFloat(savedCouponParcel) || 0,
      });
    }
  } catch (_) {}

  try {
    const stepToBack = localStorage.getItem(LOCAL_STORAGE_STEP_TO_BACK_KEY);
    if (stepToBack !== null && stepToBack !== "") {
      useBotControlStore.setState({
        stepToBack: parseInt(stepToBack, 10),
      });
    }
  } catch (_) {}

  try {
    const savedRanges = localStorage.getItem(LOCAL_STORAGE_CREDIT_RANGES_KEY);
    if (savedRanges) {
      const ranges = JSON.parse(savedRanges);
      if (ranges?.minBemValor && ranges?.maxBemValor) {
        useConsorcioStore.setState((state) => ({ ...state, ranges }));
      }
    }
  } catch (_) {}
};

export const clearResumeExtraStorage = () => {
  localStorage.removeItem(LOCAL_STORAGE_INSURANCE_KEY);
  localStorage.removeItem(LOCAL_STORAGE_CUPOM_DATA_KEY);
  localStorage.removeItem(LOCAL_STORAGE_USER_CUPOM_KEY);
  localStorage.removeItem(LOCAL_STORAGE_COUPON_FIRST_PARCEL_KEY);
  localStorage.removeItem(LOCAL_STORAGE_STEP_TO_BACK_KEY);
  localStorage.removeItem(LOCAL_STORAGE_CREDIT_RANGES_KEY);
  clearSessionConfigStorage();
};
